import { useSearchParams } from 'react-router-dom';

import Tabs from '#globalComponents/Tabs/Tabs';
import { useAuth } from '#globalContexts/AuthProvider';

import { ApiKeysSettings } from '../ApiAccessSettings/ApiKeysSettings';
import { BillingSettings } from '../BillingSettings/BillingSettings';
import { CompanySettings } from '../CompanySettings/CompanySettings';
import { NotificationSettings } from '../NotificationSettings/NotificationSettings';
import { ProfileSettings } from '../ProfileSettings/ProfileSettings';
import { SMTPSettings } from '../SMTPSettings/SMTPSettings';
import { TeamSettings } from '../TeamSettings/TeamSettings';

export const TabNavigation = () => {
	const { orgRole, orgPlan } = useAuth();
	const [searchParams, setSearchParams] = useSearchParams();
	const isPaidPlan = Boolean(orgPlan) && !['demo', 'cancelled', 'paused'].includes(orgPlan);
	const showBillingTab = orgRole === 'owner';
	const showCompanyTab = orgRole === 'owner' || orgRole === 'admin';
	const showTeamTab = (orgRole === 'owner' || orgRole === 'admin') && isPaidPlan;
	const showApiTab = orgRole === 'owner' || orgRole === 'admin';

	const tabs = [
		...(showBillingTab ? [{ id: 'billing', label: 'Abrechnung & Nutzung', component: <BillingSettings /> }] : []),
		{ id: 'profile', label: 'Konto & Informationen', component: <ProfileSettings /> },
		{ id: 'notifications', label: 'Benachrichtigungen', component: <NotificationSettings /> },
		...(showCompanyTab ? [{ id: 'company', label: 'Firma', component: <CompanySettings /> }] : []),
		{ id: 'smtp', label: 'Mail-Server', component: <SMTPSettings /> },
		...(showTeamTab ? [{ id: 'team', label: 'Team', component: <TeamSettings /> }] : []),
		...(showApiTab ? [{ id: 'api-keys', label: 'API-Schlüssel', component: <ApiKeysSettings /> }] : []),
	];

	const tabParam = searchParams.get('tab');
	const activeTab = tabs.some((t) => t.id === tabParam) ? tabParam : tabs[0]?.id;

	const handleTabChange = (tabId) => {
		setSearchParams({ tab: tabId }, { replace: true });
	};

	return (
		<div className="space-y-6">
			<Tabs tabs={tabs} activeId={activeTab} onChange={handleTabChange} />
			{tabs.find((tab) => tab.id === activeTab)?.component}
		</div>
	);
};
